import * as React from "react";
import {connect} from 'react-redux';
import * as selectors from "../../selectors";
import {DisplayFeature} from "../../domain";
import classNames = require("classnames");
import {EditLanes, editLanes} from "../../../../actions/actions";
import {closeEditor, CloseEditor} from "../../reducers/actions";
import FeaturesState from "../../domain/FeaturesState";
import {getAllLanesAsTextRelativeToMeteringDirection} from "../../../../../laneUtilities";
import LaneModal from "./LaneModal";

interface CellState {
    isValid: boolean;
}

interface TagProps {
    feature: DisplayFeature,
    hasFocus: boolean,
    loading: boolean
}

interface DispatchProps {
    updateLanes: EditLanes,
    closeEditor: CloseEditor,
}

interface StateProps {
    showEditor: boolean,
    laneIsAllowed: boolean,
}

type Props = TagProps & StateProps & DispatchProps;

class LaneCell extends React.Component<Props, CellState> {

    constructor(props: Props) {
        super(props);
        this.state = {isValid: true}
    }

    render() {

        let {feature, updateLanes, laneIsAllowed, closeEditor, loading} = this.props;

        let cellValueClasses = classNames({
            'cell-component': true,
            'cell-focus': this.props.hasFocus,
            'disabled': !laneIsAllowed || !feature.locational,
            'edited': feature.locational ? feature.locational.laneEdited : false
        });

        const displayLaneValues = getAllLanesAsTextRelativeToMeteringDirection(feature);

        let tooltip = !feature.locational ? "Vegobjektet mangler stedfesting" : !laneIsAllowed ? "Denne typen kan ikke ha felt" : "";

        if(loading){
            return <div className={"cssloader small"}/>
        }

        const editor = this.props.hasFocus && this.props.showEditor ?
            <LaneModal
                roadObject={feature}
                closeModal={closeEditor}
                doUpdateLanes={updateLanes}
            /> : null;

        return (
            <div className={cellValueClasses} title={tooltip}>
                {editor || displayLaneValues}
            </div>
        );
    }

}

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        showEditor: selectors.showEditor(state),
        laneIsAllowed: selectors.locationalLaneIsAllowed(state)
    }
};

const mapDispatchToProps = ({
    updateLanes: editLanes,
    closeEditor: closeEditor,
});

export default connect(mapStateToProps, mapDispatchToProps)(LaneCell);



